import { Injectable } from '@angular/core';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class NotificacionesService {
  constructor(private api: CloudFunctionsApiService) {}

  getNotificaciones(id) {
    return this.api.snapshotList(`/notifications/user/${id}`);
  }

  getNotificacionessinver(id) {
    return this.api.snapshotList(`/notifications/user/${id}?seen=false`);
  }

  getNotificacionesMensajes(user) {
    return this.api.snapshotList(`/notifications/user/${user}`);
  }

  getNotificacionesMensajesGrupo(clase, user) {
    return this.api.snapshotList(`/notifications/user/${user}?classId=${encodeURIComponent(clase)}`);
  }

  getNotificacionesMensajesDeEmisor(user, emisor) {
    return this.api.snapshotList(
      `/notifications/user/${user}?senderId=${encodeURIComponent(emisor)}`
    );
  }

  getNotificacionById(id) {
    return this.api.snapshotList(`/notifications/${id}`);
  }

  createdNotificacion(evento) {
    return this.api.post('/notifications', this.toApiNotification(evento)).toPromise();
  }

  editNotificacion(evento) {
    return this.api.patch(`/notifications/${evento.id}`, evento).toPromise();
  }

  removeNotificacion(id) {
    return this.api.delete(`/notifications/${id}`).toPromise();
  }

  updateNotificacion(id, update) {
    return this.api.patch(`/notifications/${id}`, update).toPromise();
  }

  searchNotification(eventid) {
    return this.api.snapshotList(`/notifications/event/${eventid}`);
  }

  private toApiNotification(notification: any) {
    const receiverId =
      notification?.reciever_id ||
      notification?.receiver_id ||
      notification?.user ||
      notification?.verlo ||
      '';
    const senderId = notification?.sender_id || notification?.emisor || '';
    const content = notification?.content || notification?.texto || '';
    const seen =
      typeof notification?.seen === 'boolean'
        ? notification.seen
        : typeof notification?.visto === 'boolean'
        ? notification.visto
        : false;
    const message =
      typeof notification?.message === 'boolean'
        ? notification.message
        : typeof notification?.mensaje === 'boolean'
        ? notification.mensaje
        : false;

    return {
      ...notification,
      reciever_id: receiverId,
      receiver_id: receiverId,
      sender_id: senderId,
      content,
      seen,
      message,
      user: notification?.user || receiverId,
      verlo: notification?.verlo || receiverId,
      emisor: notification?.emisor || senderId,
      texto: notification?.texto || content,
      fecha: notification?.fecha || notification?.date || new Date(),
      date: notification?.date || notification?.fecha || new Date(),
    };
  }
}
